import Dinero from 'dinero.js';

export const formatDollarAmount = (amountCents: number) => {
  return Dinero({ amount: amountCents }).toFormat('$0,0.00');
};

export const formatDollarAmountNumberOnly = (amountCents: number) => {
  return Dinero({ amount: amountCents }).toFormat('0.00');
};

export const formatWholeDollarAmount = (amountCents: number) => {
  return Dinero({ amount: amountCents }).toFormat('$0,0');
};

export const addAmounts = (amountOneCents: number, amountTwoCents: number) => {
  return Dinero({ amount: amountOneCents }).add(
    Dinero({ amount: amountTwoCents })
  );
};
